<script setup lang="ts">
/**
 * Use countries.
 */
const { codes } = useCountries()

/**
 * Fetch all values.
 */
const values = await apiFetch<Import[]>('imports', {
    iso: unref(codes)
})

/**
 * Country that is currently selected.
 */
const country = ref(values[0].country)

/**
 * Products that are currently selected.
 */
const products = ref<number[]>([])

/**
 * Filter values based on selected products.
 */
const filteredValues = computed(() => {
    return values.map(value => ({
        ...value,
        products: value.products.filter(product => {
            if (!unref(products).length) return true
            return unref(products).includes(product.product_id)
        })
    }))
})
</script>

<template>
    <div class="flex grid-cols-4 flex-col lg:grid">
        <HomeImportingRiskProductsSelector
            v-model:products="products"
            class="col-span-4 border border-b-0 border-stone-300 py-4"
        />
        <div
            class="col-span-3 flex flex-1 flex-col border border-stone-200 p-4 max-sm:border-b-0 lg:border-r-0"
        >
            <HomeImportingRiskGlobalData
                v-model:country="country"
                :values="filteredValues"
                class="flex-1"
            />
        </div>
        <HomeImportingRiskCountryData
            :values="filteredValues"
            :country="country"
            class="border border-stone-200 p-4"
        />
    </div>
</template>